<template>
	<div class="login">
	  <div class="login-container" :style="'transform: scale('+scle+')'">
		  <div class="top-system">
        <img class="logo" src="../assets/img/01logo1.png" width="80" height="86" alt="">
        <span class="sys-name">{{ sysName }}</span>
        <!-- <span v-if="sysNamePinyin">{{ sysNamePinyin }}</span> -->
		  </div>
      <img class="login-bg" src="../assets/img/01beijing2.png" alt=""/>
      <img class="login-bg2" src="../assets/img/01chatu1.png" alt=""/>
      <div  class="login-left">
        <div style="padding: 10px 50px">
          <span :class="dlFs==1?'left-text activite':'left-text'" @click="changeDl(1)" style="">手机号登录</span>
          <span :class="dlFs==2?'left-text activite':'left-text'"  @click="changeDl(2)">账号登录</span>
        </div>
        <div class="zh-info" v-if="dlFs == 2">
          <div class="main-input width-valid">
            <!-- <img class="input-logo" src="../assets/img/01-yonghu.png" alt=""> -->
            <!-- <img class="line" src="../assets/img/01-xiegang.png" alt=""> -->
            <input type="text" placeholder="用户名" v-model="loginName" @change="nameflg = (loginName == null || loginName == '')" />
            <div class="warin-txt">
              <template v-if="nameflg">用户名不能为空</template>
            </div>
          </div>
          <div class="main-input width-valid" style="position: relative;">
            <!-- <img class="input-logo" src="../assets/img/01-mima.png" alt=""> -->
            <!-- <img class="line" src="../assets/img/01-xiegang.png" alt=""> -->
            <input :type="mmStatus ? 'text' : 'password'" placeholder="密码" v-model="password" @change="changepsd" />
            <img src="../assets/img/kaiqi.png" alt="" style="width: 22px;position: absolute;right: 40px;top: 16px;cursor: pointer;" @click="mmClk(1)" v-if="mmStatus" />
            <img src="../assets/img/guanbi.png" alt="" style="width: 22px;position: absolute;right: 40px;top: 16px;cursor: pointer;" @click="mmClk(2)" v-if="!mmStatus" />
            <div class="warin-txt">
              <template v-if="psdflg">请输入6-16位密码</template>
            </div>
          </div>
          <div class="code-container width-valid">
            <div class="code-input">
              <input type="text" placeholder="输入验证码" v-model="code" @change="codeflg = (code == null || code == '')" />
            </div>
            <div class="code-img login-code" @click="refreshCode">
              <!-- <img @click="refreshImg" :src="imgUrl" alt=""> -->
              <!--验证码组件-->
              <s-identify :fontSizeMax="40" :identifyCode="identifyCode"></s-identify>
            </div>
            <div class="warin-txt error-txt">
              <template v-if="codeflg">请输入验证码</template>
            </div>
          </div>
        </div>
        <div class="sjh-info" v-if="dlFs == 1">
          <div class="main-input width-valid">
            <!-- <img class="input-logo" src="../assets/img/01-yonghu.png" alt=""> -->
            <!-- <img class="line" src="../assets/img/01-xiegang.png" alt=""> -->
            <input type="text" placeholder="输入手机号" v-model="loginName" @change="nameflg = (loginName == null || loginName == '')" />
            <div class="warin-txt">
              <template v-if="nameflg">手机号不能为空</template>
            </div>
          </div>
          <div class="code-container width-valid">
            <div class="code-input">
              <input type="text" placeholder="输入验证码" v-model="code" @change="codeflg = (code == null || code == '')" />
            </div>
            <div class="code-text" v-if="!showDjs" @click="getVildeCode">获取验证码</div>
            <div class="code-text" v-if="showDjs">倒计时 <span>{{ this.djs }}</span>s</div>
            <div class="warin-txt error-txt">
              <template v-if="codeflg">请输入验证码</template>
            </div>
          </div>
        </div>
        <div class="login-btn width-valid">
          <el-button @click="login">登录</el-button>
        </div>
      </div>
      <div class="browser-list">
          建议使用：
        <a href="http://baoku.360.cn/soft/show/appid/105189" target="_blank">谷歌浏览器</a>、
        <a href="http://baoku.360.cn/soft/show/appid/104511" target="_blank">火狐浏览器</a>、
        <a href="https://www.apple.com/cn/safari/" target="_blank">IE11浏览器登录</a>、
        <a  href="https://browser.360.cn/ee/" target="_blank">360极速浏览器</a>
      </div>
      <div class="browser-list banquan">{{banquan}}</div>
      <div class="browser-list fw-phone">{{fwPhone}}</div>
      <div class="browser-list kf-phone">{{kfPhone}}</div>
	  </div>
	</div>
</template>

<script>
  import SIdentify from '../components/Sidentify.vue';
  import { encrypt } from '@/assets/js/jsencrypt';

  export default{
		name: "Login",
		data() {
		  return {
        sysName: '',
        sysNamePinyin: '',
			  loginName: '',
			  password: '',
			  code: '',
			  nameflg: false,
			  psdflg: false,
			  codeflg: false,
			  identifyCodes: "1234567890",
			  identifyCode: "",
			  scle: '',
			  fwPhone: '',
        kfPhone: '',
        banquan: '',
        rsaPublicKey: '',
        rzUrl: '',
        mmStatus: false,
        timer: '',
        djs: 60,
        showDjs: false,
        dlFs: 1,
		  }
		},
    components: {
      SIdentify
    },
		mounted() {
      this.getSysName();//获取系统名称
			this.findscle();
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
		},
    created(){
      var _this = this;
      document.onkeydown = function(e) {
        var key = window.event.keyCode;
        if (key == 13) {
          _this.login();
        }
      }
      _this.refreshCode();
    },
		methods: {
      changeDl(val){
        this.dlFs = val;
      },
      pcCountDown(val) {
        clearInterval(this.timer)
        this.djs = val; // 保留初始值用于重置
        this.timer = setInterval(() => { // 改用箭头函数绑定this
          this.djs -= 1;
          if (this.djs <= 0) {
            clearInterval(this.timer);
            this.djs = 60;     // 重置倒计时数字
            this.showDjs = false; // 新增：隐藏倒计时显示
          }
        }, 1000);
      },
      //获取验证码
      getVildeCode(){
        var _this = this;
        if(_this.loginName == '' || _this.loginName == null){
          _this.$message({
            message: '请输入手机号',
            type: 'warning'
          });
          return;
        }else{
          if(!(/^1[345789]\d{9}$/.test(_this.loginName))){
            _this.$message({
              message: '手机号格式有误',
              type: 'warning'
            });
            return;
          }
        }
        _this.$post('getValidCode',{sjh: _this.loginName}).then((arg) => {
          if(arg.code == "1"){
            _this.showDjs = true;
            _this.pcCountDown(60);
          }else{
            _this.showDjs = false;
            _this.$message({
              message: arg.msg,
              type: 'error'
            });
          }
        });
      },
      mmClk(num){
        if(num == 1){
          this.mmStatus = false;
        }else if(num == 2){
          this.mmStatus = true;
        }
      },
      //获取系统名称
      getSysName(){
        this.$post('sys/findSysConfigByConfigKey',{configKey: "system_name"}).then((arg) => {
          var title = arg.result.sysConfig.configValue;
          this.sysName = title;
          sessionStorage.setItem("sysName",title);
          document.title=title;
        });
        this.$post('sys/findSysConfigByConfigKey',{configKey: "system_name_pinyin"}).then((arg) => {
          this.sysNamePinyin = arg.result.sysConfig.configValue;
        })
        this.$post('sys/findSysConfigByConfigKey',{configKey: "fw_telphone"}).then((arg) => {
          this.fwPhone = arg.result.sysConfig.configValue;
        })
        this.$post('sys/findSysConfigByConfigKey',{configKey: "kf_telphone"}).then((arg) => {
          this.kfPhone = arg.result.sysConfig.configValue;
        })
        this.$post('sys/findSysConfigByConfigKey',{configKey: "banquan"}).then((arg) => {
          this.banquan = arg.result.sysConfig.configValue;
        })
        this.$post('sys/findSysConfigByConfigKey',{configKey: "rsa_public_key"}).then((arg) => {
          this.rsaPublicKey = arg.result.sysConfig.configValue;
        })
      },
			//获取屏幕宽度
			findscle(){
				this.scle = document.body.clientWidth/1920;
			},
      //验证码
      randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      },

      refreshCode() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
      },
      makeCode(o, l) {
        for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[
              this.randomNum(0, this.identifyCodes.length)
          ];
        }
        console.log(this.identifyCode);
      },
			//点击登录
			login(){
				if(this.loginName == null || this.loginName == ''){
					this.nameflg = true;
				}
        if(this.dlFs == 2){
          if(this.password == null || this.password == ''){
            this.psdflg = true;
          }
          /*if(this.password.length < 6){
            this.psdflg = true;
          }*/
          if(this.code == null || this.code == ''){
            this.codeflg = true;
          }
          if(this.nameflg || this.psdflg || this.codeflg){
            return;
          }
          if(this.identifyCode!=this.code){
            this.code="";
            this.refreshCode();
            this.$message({
              type: "error",
              message: "请输入正确验证码"
            });
            return;
          }
          var params = {"loginName":encrypt(this.loginName,this.rsaPublicKey),"password":encrypt(this.password,this.rsaPublicKey)};
          this.$post("adminLogin",params).then(rep => {
            if (rep.code == 1) {
              var access_token = rep.result.access_token;
              sessionStorage.setItem("access_token", access_token);
              //登录成功跳转
              this.$router.push({path: '/'});
            } else {
              this.$message({
                type: "error",
                message: rep.msg
              });
            }
            //刷新验证码
            this.code = "";
            this.refreshCode();
          }).catch(e =>{
            //console.log(e)
          })
        }else if(this.dlFs == 1){
          if(this.code == null || this.code == ''){
            this.codeflg = true;
          }
          if(this.nameflg || this.codeflg){
            return;
          }
          var params = {"loginName":encrypt(this.loginName,this.rsaPublicKey),"yzm":this.code};
          this.$post("adminSjhLogin",params).then(rep => {
            if (rep.code == 1) {
              var access_token = rep.result.access_token;
              sessionStorage.setItem("access_token", access_token);
              //登录成功跳转
              this.$router.push({path: '/'});
            } else {
              this.$message({
                type: "error",
                message: rep.msg
              });
            }
            //刷新验证码
            this.code = "";
            this.refreshCode();
          }).catch(e =>{
            //console.log(e)
          })
        }
			},
			changepsd(){
				if(this.password == null || this.password == ''){
					this.psdflg = true;
					return;
				}
				this.psdflg = false;
			},
		}
	}
</script>

<style scoped lang="less">
.login {
  height: 100%; /* 使用vh单位替代calc(100%)更直观 */
  /* 蓝色渐变背景 + 底部图片组合 修正图片路径并调整层级顺序 */
  background: url(../assets/img/02beijing1.png) no-repeat bottom center, linear-gradient(18deg, #90CAFA, #559cf4);
  /* 图片宽度100%适应，渐变全屏覆盖 */
  background-size: 100% auto, cover;
	min-width: 1366px;
	min-height: 768px;
	display: flex;
	align-items: center;
	vertical-align: middle;
  .login-container {
    margin: auto;
    //bottom: 0;
    width: 850px;
    height: 450px;
    border-radius: 20px;
		position: relative;
		bottom: 90px;
    .top-system{
      position: absolute;
      top: -100px;
      width: 100%;
      text-align: center;
      h1,span{
        color: #fff;
      }
      span{
        line-height: 36px;
        color: rgba(255,255,255,.5);
        text-shadow: -1px -1px 0 rgba(18,91,152,.5), 1px -1px 0 rgba(18,91,152,.5), -1px 1px 0 rgba(18,91,152,.5), 1px 1px 0 rgba(18,91,152,.5);
      }
      h1{
        font-size: 36px;
        letter-spacing: 7px;
        text-shadow: -2px -2px 0 #125B98, 2px -2px 0 #125B98, -2px 2px 0 #125B98, 2px 2px 0 #125B98;
      }
      .sys-name{
        font-weight: bold;
        font-size: 40px;
        color: #FFFFFF;
        line-height: 62px;
        text-shadow: 0 3px 2px #3B8BDF;
        vertical-align: top;
        margin-top: 5px;
        margin-left: 28px;
        display: inline-block;
      }
    }
    .login-bg{
      height: 100%;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      position: absolute;left: -1px;
    }
    .login-bg2{
      height: 80%;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      position: absolute;
      left: 45px;
      bottom: 34px;
    }
    .login-left {
      position: absolute;
      top: 50px;
      right: 15px;
      width: 360px;
      bottom: 0;
			.sjh-info{
				margin-top: 4px;
			}
      .left-text{
        font-size: 18px;
        color: #795548;
        margin-bottom: 15px;
        padding-bottom: 3px;
        cursor: pointer;
        display: inline-block;
        opacity: 0.5;
				margin-right: calc(50% - 84px);
      }
			.left-text:last-child{
				margin-right: 0;
				margin-left: calc(50% - 84px);
			}
      .activite{
        border-bottom: 2px solid;
				font-size: 18px;
        margin-bottom: 5px;
        color: #795548;
        opacity: 1;
      }
      .login-logo {
        margin-bottom: 10px;
        width: 410px;
        height: 112px;
        img{
          width: 80%;
          height: auto;
          margin: 0 auto;
          display: block;
        }
      }
      .width-valid {
        width: 426px;
        box-sizing: border-box;
      }
      .main-input {
        height: 48px;
        line-height: 46px;
        border-radius: 33px;
        background: #E9D6BE;
        box-shadow: inset 0px 1px 5px 0px rgba(0,0,0,0.05), inset 0px 1px 5px 0px rgba(209,190,169,0.8);
        padding-left: 30px;
        width: 100%;
        margin-bottom: 30px;
        .input-logo {
          width: 20px;
          vertical-align: middle;
          margin: 0 14px 0 16px;
        }
        .line {
          vertical-align: middle;
          margin-right: 18px;
        }
        input {
          border: none;
          outline: none;
          padding: 0;
          width: 320px;
          font-size: 16px;
          font: initial;
          background: #E9D6BE;
					color: #985626;
        }
      }
      .warin-txt{
        height: 30px;
        line-height: 30px;
        text-align: left;
        color: #f85151;
        font-weight: 200;
        font-size: 12px;
        width: 50%;
        overflow: hidden;
        display: block;
      }
      .code-container {
        padding-top: 0px;
        height: 48px;
        // margin: 0 auto 28px;
        width: 100%;
        margin-bottom: 30px;
        .error-txt{
          padding-left: 30px;
        }
        .code-input {
          float: left;
          border-radius: 33px;
          //background: #fff;
          background: #E9D6BE;
					box-shadow: inset 0px 1px 5px 0px rgba(0,0,0,0.05), inset 0px 1px 5px 0px rgba(209,190,169,0.8);
          width: 230px;
          height: 47px;
          text-align: center;
          box-sizing: border-box;
          input {
            width: 80%;
            outline: none;
            padding: 0;
            border: none;
            font-size: 16px;
            background: #E9D6BE;
						margin: 15px 0;
          }
        }
        .code-img {
          width: 110px;
          height: 46px;
          float: right;
          // border-radius: 4px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }
        .code-text{
          float: right;
          width: 120px;
          border-radius: 30px;
          line-height: 45px;
          cursor: pointer;
          background: #FFFFFF;
          color: #999999;
					font-size: 14px;
					text-align: center;
        }
      }
      .login-btn {
        height: 45px;
        line-height: 45px;
        // margin: 0 auto;
        width: 100%;
        text-align: center;
        button {
          display: block;
          appearance: none;
          border: none;
          width: 100%;
          height: 45px;
          letter-spacing: 10px;
          // background: #03a9f4;
          // border-radius: 4px;
          // font-weight: 400;
          color: #fff;
          box-shadow: 0px 2px 6px 0px rgba(0,0,0, 0.3);
          cursor: pointer;

          //background: linear-gradient(90deg, #1890CF 0%, #2051B0 100%);
          background:linear-gradient(0deg,#C95000,#FFB400);
          text-shadow: 0px 2px 2px #C64800;
          border-radius: 30px;
          font-weight: 300;
          font-size: 18px;
        }
      .cz-block{
        cursor: pointer
      }
      .right-cz{
        float: right;
        color: #A5A4A6;
      }
      .left-cz{
        float: left;
        color: #03a9f4;
      }
        }
      }
    }
  .shadow-tip-ie{
    background: rgba(0,0,0,.5);
    width: 1100px;
    height: 460px;
    border-radius: 20px;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .tip-content{
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 480px;
      padding-top: 135px;
      box-sizing: border-box;
      .tip-icon{
        width: 60px;
        height: 60px;
        background: #fff;
        border-radius: 50%;
        text-align: center;
        line-height: 60px;
        padding-top: 10px;
        box-sizing: border-box;
        margin: 0 auto;
        *{
          font-size: 40px;
        }
      }
      p{
        line-height: 32px;
        color: #fff;
        font-size: 16px;
         padding: 40px 50px 0 42px;
      }
    }
  }
  .browser-list{
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -70px;
    padding-bottom: 25px;
    color: #fff;
    font-size: 14px;
    a{
      color: #fff;
      text-decoration: none;
      border-bottom: 1px solid;
      padding-bottom: 5px;
      &:hover{
        color: #2f8ed2;
        // text-decoration: underline;
      }
    }
  }
  .banquan{
    bottom: -110px;
  }
	.fw-phone{
		bottom: -140px;
	}
	.kf-phone{
		bottom: -170px;
	}
}
</style>
<style>
	.login-container{
		input, textarea {
			-webkit-box-shadow: 0 0 0 1000px #E9D6BE inset !important;
			box-shadow: 0 0 0 1000px #E9D6BE inset !important;
		}
		input::placeholder{
			color: #985626;
			font-size: 14px;
		}
	}
</style>